<div
  class="offcanvas offcanvas-bottom offcanvas-body"
  tabindex="-1"
  id="details-canvas"
  aria-labelledby="offcanvasBottomLabel"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div class="offcanvas-header p-0">
    <h5 class="offcanvas-title lg-header-text" id="offcanvasBottomLabel">{{ header }}</h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>

  <div class="offcanvas-body p-0 small" style="padding: 0">
    <div>
      <div class="package-card mt-3" *ngIf="dispatchBoxSummary">
        <div class="package-header">
          <span class="title">Package 1</span>
        </div>

        <div class="package-details">
          {{ dispatchBoxSummary.shipmentBoxName }} - {{ dispatchBoxSummary.boxName }} •
          {{ dispatchBoxSummary.items }}
          {{ dispatchBoxSummary.items === 1 ? 'item' : 'items' }}
          ({{ dispatchBoxSummary.units }} units) •
          {{ dispatchBoxSummary.weight | number: '1.2-2' }} kg
        </div>

        <div class="packed-title">Packed Items :</div>

        <div class="packed-item" *ngFor="let product of dispatchBoxSummary.products">
          <span>{{ getShortProductName(product.name ?? '') }}</span>
          <span class="qty">x {{ product.quantityPicked }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
